import React from 'react';
import NotiIcon from './noti-icon.component';

const NotificationMessage = ({ message, variant = 'amber' }) => {
  return (
    <div className={`notification-message notification-message--${variant}`}>
      <NotiIcon className="notification-message__icon" />
      <p className="notification-message__text">
        {message}
      </p>
    </div>
  );
};

export default NotificationMessage;
